import wx from "weixin-jsapi";
// 微信分享
export const wxShare = res => {
  wx.ready(() => {
    wx.onMenuShareTimeline(res);
    wx.onMenuShareAppMessage(res);
  });
};

export const wxScanQrCode =  () => {
  let result = ''
  wx.ready(() => {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        console.log(result);
        window.location.href = result;
      }
    });
  }); 
  return result
}



export const wxConfig = res => {
  wx.config({
    debug: false,
    appId: res.appid,
    timestamp: res.timestamp,
    nonceStr: res.noncestr,
    signature: res.signature,
    jsApiList: res.jsApiList
  });
};



// WEBPACK FOOTER //
// ./src/Interface/wx.js